// extracted by mini-css-extract-plugin
var _1 = "SearchResultCards-module__searchResultCards--UdICG";
export { _1 as "searchResultCards" }
